// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import store from "./store";
import moment from "moment";
import {burialPoint} from './utils/BurialPoint.js'
import ElementUI from "element-ui";
import Antd from 'ant-design-vue';
// import "element-ui/lib/theme-chalk/index.css";
import './assets/styles/variables.scss';
import 'ant-design-vue/dist/antd.css';
// import SlideVerify from "vue-monoplasty-slide-verify";


import consult from "@/components/ConsultDialog.vue";
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts;

Vue.use(mavonEditor)
// Vue.use(SlideVerify);
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.usertoken = null;
Vue.use(Antd);
Vue.use(ElementUI);


// 全局组件挂载
Vue.component('consult', consult)
router.beforeEach((to, from, next) => {
  let params = {
    userId:'',
    userName:'',
    url:to.path,
    createTime:moment().format('YYYY-MM-DD HH:mm:ss')
  }
  if(!!localStorage.getItem("userId")) {
    params.userName = localStorage.getItem("userName")
    params.userId = localStorage.getItem("userId")
  }
  
  // 如果测试环境需要更改地址
  burialPoint(params,'api/pt/arms','POST') // 正式
  // burialPoint(params,'http://47.96.70.127:88/api/pt/arms','POST') // 测试环境

  // chrome兼容
  document.body.scrollTop = 0;
  // firefox兼容
  document.documentElement.scrollTop = 0;
  // safari兼容

  window.pageYOffset = 0;
  /* 路由发生变化修改页面meta */
 
  if (to.meta.content) {
    let head = document.getElementsByTagName("head");
    let meta = document.createElement("meta");
    document
      .querySelector("#keywords")
      .setAttribute("content", to.meta.content.keywords);
    document
      .querySelector("#description")
      .setAttribute("content", to.meta.content.description);
    meta.content = to.meta.content;
    head[0].appendChild(meta);
  }
  // /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js